<template>
  <p-content-section :max-height="360" is-expandable>
    <template #header>
      <div class="sectors-header">
        <p-badge v-if="isBadgeVisible"
                 class="sectors-header__badge"
                 content="!"
                 variant="warn"/>
        <p-heading icon="branche" class="font-bold">Sectoren</p-heading>
      </div>
    </template>

    <template v-if="sortedSectorsList?.length" #content>
      <div class="sectors">
        <p-list :item-list="sortedSectorsList" />
      </div>
    </template>

    <template #empty>
      <p>
        <strong>Er zijn geen sectoren beschikbaar</strong><br />
        PIDZ vestigingen vullen jouw sectoren in op basis van de gegevens die je
        invult op je CV
      </p>
    </template>
  </p-content-section>
</template>

<script lang="ts" setup>
import { computed } from 'vue';

const props = defineProps<{
  sectors: FreelancerSector[] | undefined;
  isBadgeVisible: boolean;
}>();

const sortedSectorsList = computed(() => {
  if (!props.sectors) return;

  return props.sectors.map((obj) => obj.name).sort();
});
</script>

<style scoped lang="scss">
.sectors-header {
  position: relative;
  &__badge {
    position: absolute;
    top: -5px;
    left: 15px;
  }
}
</style>
